var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8V5.5a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5V8Zm1-2.5v14A3.5,3.5,0,0,1,19.5,23H5.5A3.5,3.5,0,0,1,2,19.5V5.5A1.5,1.5,0,0,1,3.5,4h18A1.5,1.5,0,0,1,23,5.5ZM3,9V19.5A2.5,2.5,0,0,0,5.5,22h14A2.5,2.5,0,0,0,22,19.5V9Z",
    transform: "translate(0 0)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,16a.5.5,0,0,1,0,1h-8a.5.5,0,1,1,0-1Zm-4-4a.5.5,0,1,1,0,1h-4a.5.5,0,1,1,0-1Zm8-10a.5.5,0,0,1,.5.5v3a.5.5,0,1,1-1,0v-3A.5.5,0,0,1,18.5,2ZM7.5,2a.5.5,0,0,1,.5.5v3a.5.5,0,1,1-1,0v-3A.5.5,0,0,1,7.5,2Z",
    transform: "translate(0 0)",
    fill: "#0c4767"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cd433f1b797e059e1fbc9a566b8f53f8.svg";
export { ForwardRef as ReactComponent };